import { initAnalytics } from "@/lib/analytics";
import { fmtErr } from "@/lib/utils";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize analytics before render so the first track("app_opened") inside
// App.tsx is actually captured (analytics.ts:track no-ops when uninitialized).
initAnalytics();

// initNotifications has moved into App.tsx's first useEffect so the iOS
// permission prompt is deferred out of the cold-start path.

try {
  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("missing #root mount node");
  createRoot(rootEl).render(<App />);
} catch (e) {
  const msg = e instanceof Error ? e.message : String(e);
  console.error("[yumz] boot failed:", fmtErr(e));
  // index.html exposes __yumzShowBootError to swap the splash into a
  // visible error state with a Reload button. Falls through silently if
  // the splash element is gone (e.g. dev-server scenarios).
  try { (window as any).__yumzShowBootError?.(msg); } catch {}
}
